<div class="ri-update-banner" role="status">
  <mat-icon class="banner-icon" aria-hidden="true">system_update</mat-icon>
  <div class="banner-content">
    <div class="banner-title">{{ 'APP_UPDATE.BANNER_TITLE' | translate }}</div>
    <div class="banner-body">{{ data.bodyKey | translate }}</div>
    <div class="banner-actions">
      <button mat-button class="btn-tertiary later-btn" type="button" (click)="later()">
        {{ 'APP_UPDATE.LATER' | translate }}
      </button>
      <button mat-flat-button class="btn-primary update-btn" type="button" (click)="updateNow()">
        {{ 'APP_UPDATE.UPDATE_NOW' | translate }}
      </button>
    </div>
  </div>
  <button mat-icon-button class="banner-close" type="button" (click)="later()"
    [attr.aria-label]="'APP_UPDATE.CLOSE' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>
